/**
 * Created by Jan on 08.05.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.Animations = Lfl.Animations || {};
     
    (function (Animations, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Animations, 'PerformanceLeveling')) {
            return;
        }

        /*
         |===============================================================================================================
         | Namespace definition
         |===============================================================================================================
         */
                  
        /**
         * A namespace which provides means to modify the applications performance by selectively disabling or enabling
         * certain animations based on their level of performance impact.
         *
         * NOTE: A WIP library, still experimental in terms of proper settings. The real world usage might turn out to
         * require different approach. Search for animationLevels in Confluence.
         *  
         * @memberOf Lfl.Animations
         */
        Lfl.Animations.PerformanceLeveling = Animations.PerformanceLeveling || {};
        
        (function (PerformanceLeveling, $, undefined) {
            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */
            
            
            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
            
        }(Animations.PerformanceLeveling, jQuery));       
    }(Lfl.Animations, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));